import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
export const EconomicOperatorContext = createContext(undefined);
export const EconomicOperatorContextProvider = ({ children }) => {
    const [isVisible, setIsVisible] = useState(true);
    useEffect(() => {
        // @ts-expect-error ignore storybook object
        if (window.__STORYBOOK_CLIENT_API__ || window.__STORYBOOK_ADDONS_CHANNEL__) {
            setIsVisible(true);
        }
    }, []);
    const toggleVisible = useCallback(() => {
        setIsVisible(!isVisible);
    }, [isVisible]);
    const contextValue = useMemo(() => ({
        isVisible,
        toggleVisible,
    }), [isVisible, toggleVisible]);
    return React.createElement(EconomicOperatorContext.Provider, { value: contextValue }, children);
};
export const useEconomicOperatorContext = () => {
    const appContext = useContext(EconomicOperatorContext);
    if (!appContext) {
        throw new Error('useEconomicOperatorContext must be used within a EconomicOperatorContextProvider');
    }
    return appContext;
};
